module.exports = __webpack_public_path__ + "static/img/h1-1.5a93f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd128/h1-1.png
// module id = 2/EQ
// module chunks = 1